import UpdateIcon from './component'

export default UpdateIcon
